import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-challenge-stats',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './challenge-stats.component.html',
  styleUrl: './challenge-stats.component.scss'
})
export class ChallengeStatsComponent {
  @Input() challengeHost: string = '';
  @Input() participantsCount: number = 0;
  @Input() submissionsCount: number = 0;
}


